import React, { useState, useMemo, useEffect } from 'react';
import PdfReader from '../../pures/adobePfdReader/PdfReader'
import { DialogPdf } from '../../pures';

const FollowUpDocumentPDF = (props) => {
    const {
        urlSelected
    } = props

    const [urlPdf, setUrlPdf] = useState('')
    const [blobAWS, setBlobAWS] = useState('');

    useEffect(() => {
        setUrlPdf(urlSelected)
        setBlobAWS(urlSelected)
    }, [urlSelected])

    const pdf = useMemo(() => <PdfReader useFullHeight className="pdfReader" url={urlPdf} awsURL showDownloadPDF={false} />, [urlPdf])

    return (
        <div className='followUpDocumentEntities-documentPDF' >
            <div className='followUpDocumentEntities-documentPDF-container'>
                {pdf}
            </div>
            <div className="followUpDocumentEntities-documentPDF-pdf-btn">
                <DialogPdf blobUrl={blobAWS} />
            </div>
        </div>
    )
}

export { FollowUpDocumentPDF as default }